export const CREATE_CONSULT_PACKAGE_REQUEST = "CREATE_CONSULT_PACKAGE_REQUEST";
export const FETCH_CONSULT_PACKAGES_REQUEST = "FETCH_CONSULT_PACKAGES_REQUEST";
export const FETCH_CONSULT_PACKAGE_REQUEST = "FETCH_CONSULT_PACKAGE_REQUEST";
export const UPDATE_CONSULT_PACKAGE_REQUEST = "UPDATE_CONSULT_PACKAGE_REQUEST";
